<template>
    <footer class="footer">
        <div class="footer__content">
            <h1 class="footer__title">Контактная информация</h1>
            <ul class="footer__contacts">
                <li class="footer-contact">
                    <span class="footer-contact__icon icon-phone"></span>
                    <div>
                        <p class="footer-contact__title">Телефон</p>
                        <p class="footer-contact__desc">
                            <a :href="`tel:${phoneLink}`">
                                {{ phone }}
                            </a>
                        </p>
                    </div>
                </li>
                <li class="footer-contact">
                    <span class="footer-contact__icon icon-mail"></span>
                    <div>
                        <p class="footer-contact__title">Эл. почта</p>
                        <p class="footer-contact__desc">
                            <a :href="`mailto:${email}`">
                                {{ email }}
                            </a>
                        </p>
                    </div>
                </li>
                <li class="footer-contact">
                    <span class="footer-contact__icon icon-address"></span>
                    <div>
                        <p class="footer-contact__title">Адрес</p>
                        <p class="footer-contact__desc" v-html="address"></p>
                    </div>
                </li>
            </ul>
            <div class="footer__desc" v-html="text"></div>
            <a class="logo logo_black" href="/"></a>
        </div>
    </footer>
</template>

<script>
import './footer.scss';
import Cookies from 'js-cookie';

import contacts from '@/mixins/contacts';

export default {
    name: 'Footer',
    mixins: [contacts],
    watch: {
        $route() {
            this.$forceUpdate();
        },
    },
    computed: {
        text() {
            if (this.$route.name === 'Main' && this.$DICTIONARY?.footerTextIndex)
                return this.$DICTIONARY?.footerTextIndex;

            if (!Cookies.get('sbg-in'))
                return (
          this.$DICTIONARY?.footerTextFirst || this.$DICTIONARY?.footerText
                );

            return this.$DICTIONARY?.footerText;
        },
    },
};
</script>
